/** GST rate (10%) - used for GST calculations to match backend/Attache. */
export const GST_RATE = 0.1;
